<div class="icon-skeleton loading" *ngIf="isLoading; else icon"></div>
<ng-template #icon>
  <div *ngIf="displayIcon" [style.height]="height" [style.width]="width">
    <i-feather
      [name]="iconName"
      [ngClass]="[colorClass]"
      [style.stroke-width]="strokeWidth"
    ></i-feather>
  </div>
</ng-template>
